import { RouterProvider } from '@tanstack/react-router';
import { useEffect } from 'react';
import { router, entry } from '@/routes';
export function App() {
  useEffect(() => {
    document.getElementById('root')?.setAttribute('data-app-ready', '1');
    const routes = Object.values(router.routesById)
      .filter((route) => route.id !== '__root__')
      .map((route) => {
        const data = route.options.staticData as
          | { title?: string; page?: string; standalone?: boolean; isPublic?: boolean }
          | undefined;
        return {
          pattern: route.fullPath.replace(/\$([^/]+)/g, '[$1]'),
          path: route.fullPath,
          title: data?.title ?? route.fullPath,
          page: data?.page ?? route.fullPath,
          standalone: data?.standalone === true,
          isPublic: data?.isPublic === true,
          ...(route.fullPath.includes('$') ? { entersFrom: '/filings' } : {}),
        };
      });
    (globalThis as typeof globalThis & { __onautoRouteInventory?: unknown }).__onautoRouteInventory = { routes, entry };
  }, []);
  return <RouterProvider router={router} />;
}
